module.exports = __webpack_public_path__ + "static/media/semester.ec476c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/semester.png
// module id = 250
// module chunks = 0